import * as React from 'react';
import { Icon } from '@material-ui/core';
export default function NoNotificationsCard(props) {
    return (React.createElement("div", { className: "flex justify-center items-center" },
        React.createElement("div", { className: "text-center" },
            React.createElement("div", null,
                React.createElement(Icon, { style: { color: '#CCCCCC', fontSize: '120px' } }, "notifications"),
                React.createElement("div", { style: { color: '#606060' } }, props.translate('no-new-notifications'))))));
}



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/NoNotificationsCard.tsx
// module id = 2039
// module chunks = 81